(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/hooks/use-debugger.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/hooks/use-debugger.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const useDebugger = () => {
  const [showDebugger, setShowDebugger] = useState(false);
  const handleParamLogic = debugParamValue => {
    setShowDebugger(true);
    if (debugParamValue === 'false') {
      svs.utils.paramHandler.remove({
        key: 'debuga'
      });
      svs.core.deviceSession.remove('lyckoplatsenDebug');
      setShowDebugger(false);
    } else if (!debugParamValue) {
      svs.utils.paramHandler.set({
        key: 'debuga',
        value: 'true'
      });
    }
  };
  useEffect(() => {
    const debugParamValue = svs.utils.paramHandler.get({
      key: 'debuga'
    }).value;
    svs.core.deviceSession.get('lyckoplatsenDebug', undefined, result => {
      if (result || debugParamValue === 'true') {
        handleParamLogic(debugParamValue);
        if (!result) {
          svs.core.deviceSession.set('lyckoplatsenDebug', undefined, true);
        }
      }
    });
  }, []);
  return showDebugger;
};
Object.assign(svs.lyckoplatsen.hooks, {
  useDebugger
});

 })(window);